// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1770297055362
      var cssReload = require("/data/wordpress/htdocs/wp-content/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  